import { render, staticRenderFns } from "./PasswordBasedAccess.vue?vue&type=template&id=162cccfd&"
import script from "./PasswordBasedAccess.vue?vue&type=script&lang=js&"
export * from "./PasswordBasedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports